module.exports = __webpack_public_path__ + "static/img/icon1.5c0145fe.png";